/**
 * Revision History
 * 
 * 12/31/2021   ptkim       Add
 */
import {SearchModelBase} from './SearchModelBase';
import * as XCol from '../../framework.core/XExportColumn';
import _ from 'lodash';

export enum OehListType {
    Normal,
    UseLot
}
export class OeHblListItem extends SearchModelBase {
    closed: string = '';
    shipmentType: string = '';
    invStat: string = '';
    billStat: string = '';
    crDbStat: string = '';
    hblNo: string = '';
    lotNo: string = '';
    branch: string = '';
    credit: string = '';
    custSName: string = '';
    customer: number = 0
    refNo: string = '';
    mblNo: string = '';
    smanId: string = '';
    soNo: string = '';
    projectNo: string = '';
    shipmentID: string = '';
    sName: string = '';
    shipperName: string | null = null;
    cName: string = '';
    consigneeName: string | null = null;
    nName: string = '';
    notifyName: string | null = null;
    aName: string = '';
    commodity: string = '';
    payStat: string = '';
    payDate: string | null = null;
    fromPayDate: string | null = null;
    toPayDate: string | null = null;
    bookingNo: string = '';
    hBookingNo: string = '';
    vessel: string = '';
    cutOffDate: string | null = null;
    fromCutOffDate: string | null = null;
    toCutOffDate: string | null = null;
    etd: string | null = null;
    fromEtd: string | null = null;
    toEtd: string | null = null;
    eta: string | null = null;
    fromEta: string | null = null;
    toEta: string | null = null;
    expRef: string = '';
    containerNo: string = '';
    conType: string = '';
    loadingPort: string = '';
    disCharge: string = '';
    pkgs: number = 0;
    fromPkgs: number|null = null;
    toPkgs: number|null = null;
    cbm: number = 0;
    fromCbm: number|null = null;
    toCbm: number|null = null;
    kgs: number = 0;
    fromKgs: number|null = null;
    toKgs: number|null = null;
    issuedBy: string = '';
    bookRemark: string = '';
    docRcptNo: string = '';
    plofRec: string = '';
    plofDel: string = '';
    postDate: string | null = null;
    pimsLinkId: number = 0;
    id: number = 0;
    u1ID: string = '';
    u2ID: string = '';
    createdAt: string | null = null;
    u2Date: string | null = null;
    acctCloseBy: string = '';
    acctCloseDate: string | null = null;
    pCloseDate: string | null = null;
    autoOpCloseBy: string = '';
    opCloseBy: string = '';
    opCloseDate: string | null = null;
    oeMblId: number = 0;
    confirmDate: string | null = null;
    fromConfirmDate: string | null = null;
    toConfirmDate: string | null = null;
    recognized: string = '';
    status: string = '';
    custRefNo: string = '';
    fromU2Date: string | null = null;
    toU2Date: string | null = null;
    fromCreatedAt: string | null = null;
    toCreatedAt: string | null = null;
    //Track Event
    lastEvent: string = '';
    lastEventDate: string | null = null

    private static ExportCollection: XCol.XExportColumn[] = [
        XCol.Create({ col: 0, text: 'S', width: 30, dataIndex: 'status', align: XCol.XAlignType.Center, hiddenInColumnSetup: true}),
        XCol.Create({ col: 1, text: 'R', width: 30, dataIndex: 'recognized', align: XCol.XAlignType.Center, noNullOrEmptySearch: true, hiddenInColumnSetup: true}),
        XCol.Create({ col: 39, text: 'D/ID', width: 40, dataIndex: 'shipmentType', align: XCol.XAlignType.Center, noNullOrEmptySearch: true}),
        
        XCol.Create({ col: 2, text: 'HBL', width: 100, dataIndex: 'hblNo'}),
        XCol.Create({ col: 3, text: 'Last Event', width: 85, dataIndex: 'lastEvent', noNullOrEmptySearch: true }),
        XCol.Create({ col: 5, text: 'BR', width: 40, dataIndex: 'branch', align: XCol.XAlignType.Center}),
        XCol.Create({ col: 6, text: 'Customer', width: 120, dataIndex: 'custSName'}),
        XCol.Create({ col: 7, text: 'Credit', width: 60, dataIndex: 'credit', align: XCol.XAlignType.Center}),
        XCol.Create({ col: 8, text: 'Ref. #', width: 100, dataIndex: 'refNo', defaultColumnFocus : true}),
        XCol.Create({ col: 9, text: 'MBL', width: 100, dataIndex: 'mblNo'}),
        XCol.Create({ col: 10, text: 'Sales', width: 80, dataIndex: 'smanId'}),
        XCol.Create({ col: 11, text: 'S/O', width: 80, dataIndex: 'soNo', visible: true}),
        XCol.Create({ col: 12, text: 'Project ID', width: 80, dataIndex: 'projectNo', visible: true}),
        XCol.Create({ col: 13, text: 'Shipper', width: 120, dataIndex: 'shipperName', hasCustomTooltip:true}),
        XCol.Create({ col: 14, text: 'Consignee', width: 120, dataIndex: 'consigneeName', hasCustomTooltip:true}),
        XCol.Create({ col: 15, text: 'Notify', width: 120, dataIndex: 'notifyName', hasCustomTooltip:true}),
        XCol.Create({ col: 16, text: 'Agent', width: 120, dataIndex: 'aName'}),
        XCol.Create({ col: 17, text: 'Commodity', width: 120, dataIndex: 'commodity'}),
        XCol.Create({ col: 18, text: 'P', width: 40, dataIndex: 'payStat', align: XCol.XAlignType.Center}),
        XCol.Create({ col: 19, text: 'Paid Date', width: 75, dataIndex: 'payDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 20, text: 'Carrier Booking', width: 100, dataIndex: 'bookingNo'}),
        XCol.Create({ col: 21, text: 'H. Booking', width: 120, dataIndex: 'hBookingNo'}),
        XCol.Create({ col: 22, text: 'Vessel', width: 120, dataIndex: 'vessel'}),
        XCol.Create({ col: 23, text: 'CUTOFF', width: 75, dataIndex: 'cutOffDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 24, text: 'ETD', width: 75, dataIndex: 'etd', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 25, text: 'ETA', width: 75, dataIndex: 'eta', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 26, text: 'Export Ref.', width: 100, dataIndex: 'expRef'}),
        XCol.Create({ col: 27, text: 'Container', width: 90, dataIndex: 'containerNo'}),
        XCol.Create({ col: 28, text: 'Type', width: 60, dataIndex: 'conType'}),
        XCol.Create({ col: 29, text: 'Loading Port', width: 120, dataIndex: 'loadingPort'}),
        XCol.Create({ col: 30, text: 'Discharge Port', width: 120, dataIndex: 'disCharge'}),
        XCol.Create({ col: 31, text: 'PKG(s)', width: 60, dataIndex: 'pkgs', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0', noNullOrEmptySearch: true}),
        XCol.Create({ col: 32, text: 'CBM', width: 60, dataIndex: 'cbm', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0.000', noNullOrEmptySearch: true}),
        XCol.Create({ col: 33, text: 'KGS', width: 60, dataIndex: 'kgs', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0.00', noNullOrEmptySearch: true}),
        XCol.Create({ col: 34, text: 'Issued', width: 90, dataIndex: 'issuedBy'}),
        XCol.Create({ col: 35, text: 'Dock Receipt', width: 100, dataIndex: 'docRcptNo', visible: false}),
        XCol.Create({ col: 36, text: 'Place of Receipt', width: 120, dataIndex: 'plofRec', visible: false}),
        XCol.Create({ col: 37, text: 'Place of Delivery', width: 120, dataIndex: 'plofDel', visible: false}),
        
        XCol.Create({ col: 40, text: 'INV', width: 40, dataIndex: 'invStat', align: XCol.XAlignType.Center, noNullOrEmptySearch: true, visible: false}),
        XCol.Create({ col: 41, text: 'BIL', width: 40, dataIndex: 'billStat', align: XCol.XAlignType.Center, noNullOrEmptySearch: true, visible: false}),
        XCol.Create({ col: 42, text: 'CrDb', width: 40, dataIndex: 'crDbStat', align: XCol.XAlignType.Center, noNullOrEmptySearch: true, visible: false}),
        
        XCol.Create({ col: 43, text: 'Create Date', width: 100, dataIndex: 'createdAt', type: XCol.XCellType.DateTime, visible: false,}),
        XCol.Create({ col: 44, text: 'Create by', width: 80, dataIndex: 'u1ID', visible: false}),
        XCol.Create({ col: 45, text: 'Update Date', width: 100, dataIndex: 'u2Date', type: XCol.XCellType.DateTime, visible: false,}),
        XCol.Create({ col: 46, text: 'Update by', width: 80, dataIndex: 'u2ID', visible: false}),
        
        //for use tooltip
        XCol.Create({ col: 47, text: '', width: 0, dataIndex: 'sName', hiddenInColumnSetup: true, visible: false}), 
        XCol.Create({ col: 48, text: '', width: 0, dataIndex: 'cName', hiddenInColumnSetup: true, visible: false}),
        XCol.Create({ col: 49, text: '', width: 0, dataIndex: 'nName', hiddenInColumnSetup: true, visible: false}),

        //XCol.Create({ col: 14, text: 'Cust. Ref. No', width: 100, dataIndex: 'custRefNo', visible: false}),
        // XCol.Create({ col: 22, text: 'MX', width: 40, dataIndex: 'ooMblID', type: XCol.XCellType.Bool, align: XCol.XAlignType.Center, noNullOrEmptySearch: true}),
        ];


    
    public static getExportCollection(ltype:OehListType, useBranch: boolean): XCol.XExportColumn[] {
        let expCollection = _.cloneDeep(this.ExportCollection);
        if(ltype === OehListType.Normal) expCollection = expCollection.filter(x => x.dataIndex !== "lotNo");
        if (!useBranch) expCollection = expCollection.filter(x => x.dataIndex !== 'branch');
        return expCollection;
    };
	
    public static OrderBy = { orderBy: OeHblListItem.prototype.createdAt, orderByAscending: false };

    public static MapSearchFields: {[key: string]: {[key: string]: string}} = {
        payDate: {from: 'fromPayDate', to: 'toPayDate'},
        cutOffDate: {from: 'fromCutOffDate', to: 'toCutOffDate'},
        etd: {from: 'fromEtd', to: 'toEtd'},
        eta: {from: 'fromEta', to: 'toEta'},
        pkgs: {from: 'fromPkgs', to: 'toPkgs'},
        cbm: {from: 'fromCbm', to: 'toCbm'},
        kgs: {from: 'fromKgs', to: 'toKgs'},
        createdAt: {from: 'fromCreatedAt', to: 'toCreatedAt'},
        u2Date: {from: 'fromU2Date', to: 'toU2Date'},
        confirmDate: {from: 'fromConfirmDate', to: 'toConfirmDate'},
    }
}
